import { FC } from 'react'
import cn from 'classnames'

import ChatBubble from '@/components/ChatBubble'
import { IMessage } from '@/context/types'
import { DEFAULT_PROPERTY_ICON_URL, DIRECTION } from '@/context/constants'
import { OCCUPANCY, OCCUPANCY_KEYS, PROPERTY_STATUS } from '../constants'
import StatusBadge, { StatusBadgeType } from '@/components/StatusBadge'

interface PropertyCardProps {
  message: IMessage
}

const PropertyCard: FC<PropertyCardProps> = ({ message }) => {
  const { status, unitType, occupancy, title, image } = message.metadata || {}

  return (
    <>
      <ChatBubble direction={DIRECTION.RIGHT}>
        <div className="sm:pmui-text-xs md:pmui-text-sm pmui-font-eina03 pmui-whitespace-pre-wrap">
          I need help related to this property:
        </div>
      </ChatBubble>
      <div className="pmui-flex pmui-justify-end">
        <div
          className={cn(
            'pmui-p-3 pmui-w-80 pmui-h-40 pmui-flex pmui-flex-col pmui-flex-shrink-0 pmui-text-sm pmui-text-left pmui-rounded-lg carousel-box',
          )}
        >
          <div className="pmui-flex pmui-flex-col sm:pmui-flex-row pmui-relative">
            <img
              src={image || DEFAULT_PROPERTY_ICON_URL}
              alt="Property"
              className="pmui-h-20 pmui-w-28 pmui-rounded pmui-hidden sm:pmui-block"
            />
            <div className="pmui-font-rubik pmui-font-semibold pmui-text-xl pmui-ml-4 pmui-pr-0 sm:pmui-pr-10 lg:pmui-pr-0">
              {title}
            </div>
          </div>
          <div className="pmui-flex pmui-space-x-2 pmui-mt-4 pmui-w-full">
            {status.toUpperCase() === PROPERTY_STATUS.TERMINATED && (
              <StatusBadge type={StatusBadgeType.error} text="Terminated" />
            )}
            <StatusBadge
              type={
                occupancy.toUpperCase() === OCCUPANCY_KEYS.VACANT
                  ? StatusBadgeType.default
                  : StatusBadgeType.success
              }
              text={
                OCCUPANCY[
                  occupancy.toUpperCase() === OCCUPANCY_KEYS.VACANT
                    ? OCCUPANCY_KEYS.VACANT
                    : OCCUPANCY_KEYS.RENTER_OCCUPIED
                ]
              }
            />
            <div className=" pmui-flex-1" />
            <div className="pmui-flex pmui-space-x-1">
              <div>
                <span
                  className={cn('icon', {
                    'icon-ic-multi-family': unitType === 'Multi Unit',
                    'icon-ic-single-family': unitType !== 'Multi Unit',
                  })}
                />
              </div>
              <p>
                {unitType === 'Multi Unit'
                  ? 'Multi Family'
                  : unitType === 'Single Unit'
                  ? 'Single Family'
                  : 'Unit'}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PropertyCard
